'use client';
import { Dialog } from './dialog.js';
import { DialogBlock } from './dialog-block.js';
import { DialogTrigger } from './dialog-trigger.js';
import { DialogTriggerContext } from './dialog-trigger-context.js';

/**
 * Dialog component, used to display a Dialog dialog.
 *
 * @example
 * <Dialog.TriggerContext>
 *   <Dialog.Trigger>Open Dialog</Dialog.Trigger>
 *   <Dialog>
 *     <Dialog.Block>
 *       Content
 *     </Dialog.Block>
 *   </Dialog>
 * </Dialog.TriggerContext>
 */
const DialogComponent = Object.assign(Dialog, {
    Block: DialogBlock,
    TriggerContext: DialogTriggerContext,
    Trigger: DialogTrigger,
});
DialogComponent.Block.displayName = 'Dialog.Block';
DialogComponent.TriggerContext.displayName = 'Dialog.TriggerContext';
DialogComponent.Trigger.displayName = 'Dialog.Trigger';

export { DialogComponent as Dialog, DialogBlock, DialogTrigger, DialogTriggerContext };
